import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
export { ImportesPP } from "./importes";

import { TarifaPPForm } from "./form";
const TarifaPPFormRx = componentToRx(TarifaPPForm);
type Entity = models.TarifaPP;
const resource = resources.TarifaPP;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value: Promise<Entity> | Entity;
}
class TarifaPPEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue() };
    }
    get id(): number | "new" {
        const id = this.props.match.params.id;
        return id == "new" ? id : Number.parseInt(id);
    }
    async getValue() {
        if (this.id == "new") {
            return {
                Descuentos: [] as models.TarifaPPDescuento[],
                ServiciosAdicionales: {},
            } as Entity;
        } else {
            return await resource.get(this.id);
        }
    }

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onGuardar = async () => {
        const id = this.id;
        const func = id == "new" ? resource.add : resource.update;
        const value = await this.state.value;
        await func(value);
        history.go("../");
    }

    render() {
        const props = this.props;
        const params = props.match!.params.id;
        return <TarifaPPFormRx
            value={this.state.value}
            onChange={this.onChange}
            nuevo={this.id == "new"}
            onGuardar={this.onGuardar} />;
    }
}

export const TarifaPPEdit = withRouter(TarifaPPEditComp);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifapp/edit/index.tsx